export type Unpack<A> = A extends Array<infer E> ? E : A

/**
 * Remove {} from T
 */
export type NoEmpty<T> = T extends object ? (keyof T extends never ? never : T) : T

/**
 * Distribute a Omit over a interface union (works with single interface too)
 */

// biome-ignore lint/suspicious/noExplicitAny: too variadic
export type DistributiveOmit<T, K extends keyof any> = T extends any ? Omit<T, K> : never

/**
 * Distribute a Pick over a interface union (works with single interface too)
 */
// biome-ignore lint/suspicious/noExplicitAny: too variadic
export type DistributivePick<T, K extends keyof T> = T extends any ? Pick<T, K> : never

export const isDefined = <T>(v: T): v is NonNullable<T> => v !== undefined && v !== null

export const isNotEmpty = <T>(v: T): v is NonNullable<T> => v !== undefined && v !== null && v !== ""

export const isDefinedOrNull = <T>(v: T | null | undefined): v is T | null => v !== undefined || v === null

export const toStringValue = (value: unknown): string | undefined => (typeof value === "string" ? value : undefined)

export const urlToString = (value: unknown): string | undefined => {
	if (value == null) return undefined
	if (typeof value === "string") return value
	if (value instanceof URL) return value.href
	if (typeof value === "object" && "href" in value && typeof value.href === "string") {
		return value.href
	}
	return String(value)
}

export const toNumber = (value: unknown): number | undefined => {
	return typeof value === "number" ? value : undefined
}

export const toBoolean = (value: unknown): boolean | undefined => {
	return typeof value === "boolean" ? value : undefined
}

export type NullToUndefined<T> = T extends null ? undefined : T extends infer U | null ? U | undefined : T

export type Flatten<T> = {
	[K in keyof T]: T[K] extends object ? Flatten<T[K]> : { [P in K]: T[K] }
}[keyof T]

export type UnionToIntersection<U> = (U extends unknown ? (k: U) => void : never) extends (k: infer I) => void
	? I
	: never

export type FlatObject<T> = UnionToIntersection<Flatten<T>>

export type Input<TData, TExtra extends Record<string, unknown> = Record<string, never>> = Partial<FlatObject<TData>> &
	TExtra

export const toStringWithFallback = (value: unknown, fallback = ""): string => {
	return typeof value === "string" ? value : fallback
}

export const toOptionalString = (value: unknown): string | null => {
	return typeof value === "string" ? value : null
}
